import {Component, Renderer2, ElementRef, Input, ChangeDetectorRef, OnInit} from "@angular/core";
import {CheckboxButtonComponent} from "./checkbox.button.component";

@Component({
    selector: 'checkbox-item',
    host: {
        '(click)': 'selectItem()'
    },
    template: require('./checkbox.item.template.html')
})
export class CheckboxItemComponent implements OnInit {

    @Input() private value:string;
    private isActive:boolean;

    constructor(private el:ElementRef,
                private renderer:Renderer2,
                private checkboxButton:CheckboxButtonComponent,
                private cd:ChangeDetectorRef) {
    }

    ngOnInit() {
        this.setupStyles();
        this.checkboxButton.registerComponent(this);
    }

    public setupStyles() {
        this.renderer.addClass(this.el.nativeElement, 'btn');
    }

    public updateView() {
        if (!!this.getIsActive()) {
            this.renderer.addClass(this.el.nativeElement, 'btn-primary');
            this.renderer.removeClass(this.el.nativeElement, 'btn-default');
        } else {
            this.renderer.removeClass(this.el.nativeElement, 'btn-primary');
            this.renderer.addClass(this.el.nativeElement, 'btn-default');
        }
        this.cd.detectChanges();
    }

    public setWidth(width:string) {
        this.renderer.setStyle(this.el.nativeElement, 'width', width);
    }

    public setActive(isActive:boolean) {
        this.isActive = isActive;
        this.updateView();
    }

    public getIsActive():boolean {
        return this.isActive;
    }

    public toggle() {
        this.setActive(!this.isActive);
        this.updateView();
    }

    public selectItem() {
        this.checkboxButton.selectItem(this);
    }

    public getValue() {
        return this.value;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/checkbox/checkbox.item.component.ts